import type {$Values} from 'utility-types'

import {
  getAgentsHref,
  getChangesHref,
  getFavoriteBuildsHref,
  getInvestigationsHref,
  getOverviewHref,
  getPipelinesHref,
  getQueueHref,
} from '../../../routes'
import {internalProps} from '../../../types/BS_types'
import {resolveRelative} from '../../../utils/url'

const USE_NEW_QUEUE_PAGE: boolean = internalProps['teamcity.ui.sakuraQueuePage.enabled']
const USE_NEW_INVESTIGATIONS_PAGE: boolean = internalProps['teamcity.ui.newInvestigationsPage']

export const LINKS = {
  overview: {
    sakura: getOverviewHref({}),
    classic: resolveRelative('/overview.html'),
  },
  agents: {
    sakura: getAgentsHref(),
    classic: resolveRelative('/agents.html'),
  },
  changes: {
    sakura: getChangesHref(),
    classic: resolveRelative('/changes.html'),
  },
  buildQueue: {
    sakura: USE_NEW_QUEUE_PAGE ? getQueueHref() : null,
    classic: resolveRelative('/queue.html'),
  },
  pipelines: {
    sakura: getPipelinesHref(),
    classic: null,
  },
  favoriteBuilds: {
    sakura: getFavoriteBuildsHref(),
    classic: resolveRelative('/favoriteBuilds.html'),
  },
  investigations: {
    sakura: USE_NEW_INVESTIGATIONS_PAGE ? getInvestigationsHref() : null,
    classic: resolveRelative('/investigations.html', {init: '1'}),
  },
  logout: {
    sakura: null,
    classic: resolveRelative('/ajax.html?logout=1'),
  },
  login: {
    sakura: null,
    classic: resolveRelative('/login.html'),
  },
  administration: {
    sakura: null,
    classic: resolveRelative('/admin/admin.html'),
  },
  profile: {
    sakura: null,
    classic: resolveRelative('/profile.html?init=1'),
  },
  search: {
    sakura: null,
    classic: resolveRelative('/searchResults.html?query='),
  },
}

export type LinkType = $Values<typeof LINKS>
